import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import constants from "constants";
import { apiGetCertificates } from "../../sagas/webinars";

function CertificateLink({ token, webinarId }) {
  return (
    <div
      className="container_download col l1"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <a
        onClick={() => apiGetCertificates(webinarId)}
        target="_blank"
        className="cursor-pointer"
      >
        <p className="section_live_download"></p>
      </a>
      <a onClick={() => apiGetCertificates(webinarId)} target="_blank">
        <img
          src="/assets/img/download_zoom.png"
          alt="icon"
          className="cursor-pointer"
        />
      </a>
    </div>
  );
}

CertificateLink.defaultProps = {};

CertificateLink.propTypes = {};

export default CertificateLink;



// WEBPACK FOOTER //
// ./src/components/CpdLocker/CertificateLink.jsx